import { type MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Button as MuiButton } from "@mui/material";

import { sizeIconElement } from "ui/button/button.helpers";
import { type ButtonProps } from "ui/button/button.types";

import { BUTTON_GLYPH } from "theme";

export const Button = ({
  variant = "contained",
  size = "medium",
  to,
  onClick,
  type,
  startIcon,
  endIcon,
  ref,
  children,
  ...rest
}: ButtonProps) => {
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (to) {
      navigate(to);
    }
    onClick?.(event);
  };

  return (
    <MuiButton
      ref={ref}
      type={type ?? "button"}
      variant={variant}
      size={size}
      startIcon={sizeIconElement(startIcon, BUTTON_GLYPH[size])}
      endIcon={sizeIconElement(endIcon, BUTTON_GLYPH[size])}
      onClick={handleClick}
      {...rest}>
      {children}
    </MuiButton>
  );
};
